// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import theme from '../../../theme-config';
import { ItemsPickerButton, Icon } from '../../../components/common';

type Props = {
  label: string,
  onPress: Function,
  isLoading?: boolean,
};

class ManageLinesItemsPickerButton extends Component<Props> {
  renderArrow() {
    return <Icon name="arrow-right" size={18} style={styles.arrowStyle} />;
  }

  render() {
    return (
      <ItemsPickerButton
        {...this.props}
        iconName={'plus'}
        labelStyle={styles.labelText}
        renderArrow={this.renderArrow}
        isLoading={this.props.isLoading}
      />
    );
  }
}

const styles = StyleSheet.create({
  arrowStyle: {
    color: theme.manageLines.iconColor,
  },
  labelText: {
    fontWeight: 'normal',
  },
});

export default ManageLinesItemsPickerButton;
